export default {
  notAvailable: 'Currently not available.',
  noServices: 'This company does not provide any services yet.',
  noGalleryImages: 'You have not uploaded any images yet. You can do so by clicking the \'UPLOAD\' button.',
  unexpectedError: 'Oops! Something went wrong.',
  emailNotConfirmed: {
    header: 'Your email is not verified.',
    message: 'Please check your mailbox. If you have not received a verification email, you can request a resend verification email.'
  },
  addCompany: {
    emailNotVerified: 'You must verify your email for adding a company.'
  },
  login: {
    badCredentials: 'Incorrect login credentials.'
  },
  register: {
    alreadyExists: 'An account with this email already exists.',
    notValidEmailOrPassword: 'Your email or password is incorrect.',
    passwordsDontMatch: 'These passwords do not match.'
  },
  resetPassword: {
    emailNotValid: 'An email is not correct.'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/errors.js